import {ref} from "vue";
import {sponsorshipApi} from "@/container";

const useReferral = () => {
    const referral = ref<string | undefined>(undefined);
    const referralError = ref<string | undefined>(undefined);

    /**
     * Verify the referral code.
     */
    const verifyReferral = async (): Promise<boolean> => {
        if (!referral.value?.length) {
            referralError.value = undefined;

            return true;
        }

        try {
            const response = await sponsorshipApi().check(referral.value);

            if (!response.success) {
                referralError.value = 'Le code de parrainage n\'est lié à aucune organization';
                return false;
            }

            referralError.value = undefined;

            return true;
        } catch {
            referralError.value = 'Le code de parrainage n\'est pas valide, respecter bien les majuscules et minuscules du code';
            return false;
        }
    };

    return {
        referral,
        referralError,
        verifyReferral
    };
};

export default useReferral;
